






















import { defineComponent } from '@vue/composition-api'

/**
 * 共通 モーダル 拒否コード テンプレート
 */
export default defineComponent({
  name: 'ModalDeclineMessageParts',
  props: {
    declineCode: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    nextUserAction: {
      type: String,
      default: '',
    },
  },
})
